import * as product from '@/services/rest-api/lib/product/product'

const fields = [
  {
    name: 'product_id',
    key: 'product.name',
    label: 'Nama Produk',
    placeholder: 'Pilih Produk',
    modalTitle: 'Pilih Produk',
    isEditable: true,
    isSortable: true,
    type: 'value-help-v2',
    size: 'sm',
    validation: 'required',
    trackBy: 'id',
    displayedBy: 'name',
    listGetter: product.get,
    thStyle: 'width: 300px',
    tableFields: [
      {
        label: 'Nama Produk',
        key: 'name',
        isSortable: true,
      },
      {
        label: 'Jenis Produk',
        key: 'product_type.name',
        isSortable: true,
      },
      {
        label: 'Kategori Produk',
        key: 'product_type.product_category.name',
        isSortable: true,
      },
    ],
  },
  {
    name: 'product_type',
    key: 'product.product_type.name',
    label: 'Jenis Produk',
    isSortable: true,
    thStyle: 'width: 200px',
  },
  {
    name: 'quantity',
    key: 'quantity',
    label: 'Kuantitas',
    _type: 'number',
    size: 'sm',
    placeholder: 'Masukkan Kuantitas',
    validation: 'bail|required|number|min:1,value|max:10000000,value',
    'validation-messages': {
      min: 'Harus lebih dari 0',
      max: 'Maksimal 10,000,000'
    },
    value: 1,
    isEditable: true,
    isSortable: true,
    thStyle: 'width: 100px',
  },
  {
    name: 'uom',
    key: 'uom',
    label: 'Satuan Kuantitas',
    placeholder: 'Pilih Satuan',
    isEditable: true,
    validation: 'required',
    type: 'select-resourceful-v2',
    size: 'sm',
    trackBy: 'name',
    optionsGetter: null,
    optionLabelFn: ({ item }) => item.name,
    thStyle: 'width: 130px',
  },
  {
    name: 'total_weight',
    key: 'total_weight',
    label: 'Berat',
    isSortable: true,
    afterText: 'Kg',
    thStyle: 'width: 200px',
  },
  {
    name: 'total_volume',
    key: 'total_volume',
    label: 'Volume',
    isSortable: true,
    afterText: 'Cbm',
    thStyle: 'width: 200px',
  },
  {
    name: 'note',
    key: 'note',
    label: 'Catatan',
    placeholder: 'Tulis disini...',
    isEditable: true,
    type: 'text',
    thStyle: 'width: 200px',
  },
]

export default fields
